import React, { useEffect, useState } from 'react';
import api from '../services/api';
import SearchableSelect from '../components/SearchableSelect';
import IconButton from '../components/IconButton';
import DateInput from '../components/DateInput';
import { useNavigate } from 'react-router-dom';

export default function TimeLogsPage() {
  const [logs, setLogs] = useState([]);
  const [users, setUsers] = useState([]);
  const [filters, setFilters] = useState({ userId: '', taskId: '', startDate: '', endDate: '' });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const fetchUsers = async () => {
    try {
      const res = await api.get('/users');
      setUsers(res.data || []);
    } catch (err) {
      console.error('Failed to load users', err);
    }
  };

  const fetchLogs = async () => {
    try {
      setLoading(true);
      const params = {};
      if (filters.userId) params.userId = filters.userId;
      if (filters.taskId) params.taskId = filters.taskId;
      if (filters.startDate) params.startDate = filters.startDate;
      if (filters.endDate) params.endDate = filters.endDate;
      const res = await api.get('/time-logs', { params });
      setLogs(res.data || []);
      setError(null);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to load time logs');
      setLogs([]);
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setFilters({ userId: '', taskId: '', startDate: '', endDate: '' });
    fetchLogs();
  };

  useEffect(() => {
    fetchUsers();
    fetchLogs();
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    fetchLogs();
  };


  const handleDelete = async (log) => {
    if (!window.confirm('Delete this time log?')) return;
    try {
      await api.delete(`/tasks/${log.task_id}/time-logs/${log.id}`);
      setLogs(prev => prev.filter(l => l.id !== log.id));
      alert('Time log deleted successfully');
    } catch (err) {
      alert(err.response?.data?.error || 'Failed to delete time log');
    }
  };

  return (
    <div className="clients-container" style={{ paddingTop: 12 }}>
      <div className="table-header" style={{ marginBottom: 12 }}>
        <div>
          <h2 style={{ textAlign: 'center' }}>Time Logs</h2>
          <div style={{ marginTop: "-30px", paddingBottom: "20px" }}>
            <button className="back-btn" onClick={() => navigate('/tasks')}>Back to Tasks</button>
          </div>
        </div>
      </div>

      <div style={{ marginBottom: 12 }}>
        <form onSubmit={handleSearch} style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
          <div style={{ minWidth: 200 }}>
            <SearchableSelect
              value={filters.userId}
              options={users.map(u => ({ value: u.id, label: `${u.firstName} ${u.lastName} (${u.email})` }))}
              onChange={(e) => setFilters({ ...filters, userId: e.target.value })}
              placeholder="Select user..."
              isClearable={true}
            />
          </div>
          <div>
            <label style={{ fontSize: 12 }}>Task Id:</label>
            <input placeholder="Task ID" value={filters.taskId} onChange={e => setFilters({ ...filters, taskId: e.target.value })} />
          </div>
          <div style={{ minWidth: 160 }}>
            <DateInput label="From" value={filters.startDate} onChange={val => setFilters({ ...filters, startDate: val })} />
          </div>
          <div style={{ minWidth: 160 }}>
            <DateInput label="To" value={filters.endDate} onChange={val => setFilters({ ...filters, endDate: val })} />
          </div>
          <button type="submit" className="generate-btn">Search</button>
          <button type="button" onClick={handleClear} className="back-btn">Clear</button>
        </form>
      </div>

      <div className="table-responsive">
        {loading ? <div>Loading...</div> : (
          <table className="table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Task ID</th>
                <th>User</th>
                <th>Duration</th>
                <th>Description</th>
                <th>Logged At</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {logs.length === 0 ? (
                <tr><td colSpan={7}>No time logs found</td></tr>
              ) : logs.map(l => (
                <tr key={l.id}>
                  <td>{l.id}</td>
                  <td>
                    <a href={`/tasks/edit/${l.task_id}`}>
                      {l.Task?.type ? `${l.Task.type} - ${l.task_id}` : l.task_id}
                    </a>
                  </td>
                  <td>{l.logged_by ? `${l.logged_by.firstName || ''} ${l.logged_by.lastName || ''} (${l.logged_by.email})` : '-'}</td>
                  <td>{(l.duration_minutes ? (l.duration_minutes / 60).toFixed(2) : '0.00')} hrs</td>
                  <td>{l.description || '-'}</td>
                  <td>{new Date(l.created_at).toLocaleString()}</td>
                  <td>
                    <IconButton title="Delete" onClick={() => handleDelete(l)}>
                      <svg viewBox="0 0 24 24" fill="none"><path d="M3 6h18" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/><path d="M8 6v12a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/><path d="M10 11v6M14 11v6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                    </IconButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <style jsx>{`
        .generate-btn { background:#0057b7; color:#fff; padding:8px 10px; border-radius:6px; border:none; cursor:pointer; }
      `}</style>
    </div>
  );
}
